<template>
  <div class="coupon-login">
    <div class="top">
      <div class="avatar">
        <div class="avatar-inner"></div>
      </div>
      <div class="title">众连权益.Benefits Platform</div>
      <div class="subtitle">2026 运营商专属数字化权益平台</div>
    </div>

    <van-form @submit="onSubmit" class="form">
      <van-field
        v-model="mobile"
        type="tel"
        maxlength="11"
        placeholder="请输入手机号"
        clearable
        input-align="left"
        class="field"
      >
        <template #left-icon>
          <van-icon name="phone-o" />
        </template>
      </van-field>

      <van-field
        v-model="secret"
        type="password"
        placeholder="请输入登录密钥"
        clearable
        input-align="left"
        class="field"
      >
        <template #left-icon>
          <van-icon name="lock" />
        </template>
      </van-field>

      <div class="btn-wrap">
        <van-button
          block
          class="btn-primary"
          native-type="submit"
          :loading="loading"
          :disabled="!mobile || !secret"
        >
          登录
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { loginCoupon } from '@/api/coupon'
import { mapState } from 'vuex'
import { Toast } from 'vant'
export default {
  name: 'couponLogin',
  computed: {
    ...mapState(['user'])
  },
  data() {
    return {
      mobile: '',
      secret: '',
      loading: false
    }
  },
  methods: {
    async onSubmit() {
      if (!this.mobile || !this.secret) return
      this.loading = true
      try {
        const { data } = await loginCoupon({ mobile: this.mobile, secret: this.secret })
        if (data && data.token) {
          this.$store.dispatch('AddUser', { token: data.token })
          Toast.success('登录成功')
          // const redirect = this.$route.query.redirect
          // if (redirect) {
          //   this.$router.replace(redirect)
          // } else {
            this.$router.replace({ name: 'couponIndex' })
          // }
        } else {
          Toast.fail('登录失败，请检查密钥')
        }
      } catch (e) {
        Toast.fail('登录失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
.coupon-login {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0a79c 0%, #f4b6ac 38%, #f7f7f8 70%, #f7f7f8 100%);
  padding: 2rem 0.7rem 1rem;
  padding-bottom: calc(1rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
.coupon-login::before,
.coupon-login::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(155, 27, 27, 0.2);
  filter: blur(0.02rem);
}
.coupon-login::before {
  width: 4.2rem;
  height: 4.2rem;
  top: -1.6rem;
  left: -1.4rem;
}
.coupon-login::after {
  width: 3.6rem;
  height: 3.6rem;
  top: -1.8rem;
  right: -1.2rem;
}
.top {
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}
.avatar {
  display: none;
}
.title {
  font-size: 0.56rem;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 0.06rem 0.12rem rgba(0, 0, 0, 0.16);
}
.subtitle {
  margin-top: 0.18rem;
  font-size: 0.34rem;
  color: rgba(255, 255, 255, 0.86);
}
.form {
  margin-top: 0.25rem;
  position: relative;
  z-index: 1;
}
.field {
  background: #ffffff;
  border-radius: 0.16rem;
  margin-bottom: 0.28rem;
  overflow: hidden;
  box-shadow: 0 0.12rem 0.22rem rgba(155, 27, 27, 0.12);
}
/* van-field 默认 padding 在灰底上会显得松，收紧些 */
.field :deep(.van-cell) {
  padding: 0.34rem 0.36rem;
  background: transparent;
}
.field :deep(.van-field__left-icon) {
  margin-right: 0.2rem;
  color: #9c9c9c;
}
.btn-wrap {
  margin-top: 0.65rem;
}
.btn-primary {
  height: 1rem;
  border-radius: 0.12rem;
  background: #9b1b1b;
  border: none;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.04rem;
}
.btn-primary:active {
  opacity: 0.92;
}
.btn-primary.van-button--disabled {
  background: #f2b3bb;
  opacity: 1;
}
</style>
